<script setup>
import CountTo from './CountTo.vue';
import { onMounted, ref, onBeforeUnmount } from 'vue';
// import { ElCarousel, ElCarouselItem } from 'element-plus'
import { getRoomShowave } from "@/api/common";
import { useRouter } from "vue-router";
const { currentRoute } = useRouter();
const router = currentRoute.value
let result = ref([])
let timer;
onBeforeUnmount(() => {
    clearTimeout(timer)
})
onMounted(() => {
    getData();
})
const getData = () => {
    getRoomShowave(router.query.projectId).then(res => {
        if (res.success) {
            result.value = res.data;
            // let list = [];
            // for (var i = 0, len = data.length; i < len; i += 6) {
            //     list.push(data.slice(i, i + 6));
            // }
            // result.value = list;
            timer = setTimeout(() => {
                getData();
            }, 10 * 1000)
        }
    })
}
</script>
<template>
    <div class="temp-box">
        <div class="mt-10">
            <b class="colorLG title-bg fz-sm">TEMPERATURE MONITOR</b>
            <b class="ml-6 fz-sm colorWhite">库内温度</b>
        </div>
        <ul class="cool-room-list">
            <li v-for="(item, index) in result" :key="'list-' + index" class="cool-room-item">
                <p class="cool-room-name">{{ item.roomName }}</p>
                <div class="item-info">
                    <p>
                        <span class="iconfont circle icon-caozuo-wendu"></span>
                        <b class="colorLG fz-lg">
                            <span v-if="item.showaveTtValue === null">--</span>
                            <CountTo v-else :temp="item.showaveTtValue"></CountTo>
                        </b>
                        <b class="fz-xs">°C</b>
                    </p>
                </div>
            </li>
        </ul>
        <!-- <el-carousel v-if="result.length" height="165px" :interval="5000">
                <el-carousel-item v-for="(list, index) in result" :key="'item-' + index">
                    <ul class="cool-room-list">
                        <li v-for="(item, index) in list" :key="'list-' + index" class="cool-room-item">
                            <p class="cool-room-name">{{ item.roomName }}</p>
                            <div class="item-info">
                                <p>
                                    <span class="iconfont circle icon-caozuo-wendu"></span>
                                    <b class="colorLG fz-lg">
                                        <span v-if="item.showaveTtValue === null">--</span>
                                        <CountTo v-else :temp="item.showaveTtValue"></CountTo>
                                    </b>
                                    <b class="fz-xs">°C</b>
                                </p>
                                <p class="mt-20">
                                    <span class="iconfont circle icon-shidu"></span>
                                    <b class="colorY fz-lg">
                                        <span v-if="item.showaveHtValue === null">--</span>
                                        <CountTo v-else :temp="item.showaveHtValue"></CountTo>
                                    </b>
                                    <b class="fz-xs">%</b>
                                </p>
                            </div>
                        </li>
                    </ul>
                </el-carousel-item>
            </el-carousel> -->

    </div>
</template>
<style lang="scss" scoped>
.temp-box {
    position: absolute;
    bottom: 10px;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
}

.title-bg {
    padding: 4px 26px;
    background-color: #0a2b30;
}

.cool-room-list {
    display: flex;
    flex-wrap: wrap;
    height: 172px;
    margin-top: 6px;
    font-size: 14px;
    color: #fff;
    background-image: linear-gradient(rgba(0, 252, 252, 0.1) 0%, rgba(0, 0, 0, 0) 100%);
    overflow: hidden;
}

.cool-room-item {
    width: 20%;
    min-width: 146px;
    padding-left: 20px;
    box-sizing: border-box;
    .item-info {
        border-left: 1px solid rgba(132, 139, 159, 0.5);
    }
}

.cool-room-name {
    padding: 10px 10px;
    font-weight: bold;
    box-sizing: border-box;
}

.item-info {
    padding: 10px;
    box-sizing: border-box;
}
.cool-room-item:nth-child(1) {
    .item-info {
        border-left: none;
    }
}
.cool-room-item:nth-child(6) {
    .item-info {
        border-left: none;
    }
}

.circle {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin-right: 10px;
    line-height: 28px;
    text-align: center;
    border: 1px solid #00fcfc;
    color: #00fcfc;
    font-size: 20px;
    border-radius: 50%;
}
</style>